import "./App.scss"
import React, { Component } from "react"
import { authStore, productStore } from "./stores"
import { BrowserRouter, Route, Link } from "react-router-dom"
import { observer } from "mobx-react"
import { Icon, AppHeader, AppPanel, AppSidebar } from "./lib"
import styled from "styled-components"
import Switch from "react-toggle-switch"

const CharityItem = styled.div`
  display: flex;
  text-align: left;
  padding: 20px;
  border-radius: 10px;
  border: 1px solid #ddd;
  cursor: pointer;
  margin-top: 40px;
  background: #f5f5f5;
`

@observer
export default class Payment extends Component {
  render() {
    var store = authStore.store
    return (
      <div>
        <AppHeader>
          <h1>Payment</h1>
        </AppHeader>
        <AppPanel style={{ textAlign: "center" }}>
          {authStore.donateEnabled ? null : (
            <div>
              {store && store.stripeAccount ? (
                <div>
                  <h4 style={{ padding: 25 }}>Your Stripe account is connected.</h4>
                  <p>
                    Profits from your store will be automatically deposited<br /> to your account on
                    the 1st of each month.
                  </p>
                  <p
                    style={{ paddingBottom: 25, paddingTop: 10, fontStyle: "italic", opacity: 0.5 }}
                  >
                    (Deposit transfer fee is 25 cents.)
                  </p>

                  <button
                    className="button Button-submit"
                    onClick={authStore.stripeTransfers}
                    style={{ width: 250, margin: "0 auto" }}
                  >
                    View Payments on Stripe&nbsp;&nbsp;&nbsp;
                    <Icon name="forward" size={12} color="#fff" />
                  </button>
                </div>
              ) : (
                <div>
                  <h4>Connect your TinyMerch account to Stripe</h4>
                  <p style={{ padding: 25 }}>
                    We use Stripe to make sure you get paid on time<br /> and keep your personal and
                    bank details secure.
                  </p>
                  <button
                    className="button Button-submit"
                    onClick={authStore.stripeAuthorize}
                    style={{ width: 270, margin: "0 auto" }}
                  >
                    Setup Payments on Stripe&nbsp;&nbsp;&nbsp;
                    <Icon name="forward" size={12} color="#fff" />
                  </button>
                </div>
              )}
            </div>
          )}

          <div
            style={{
              padding: "25px 20px",
              border: "1px solid #eee",
              borderRadius: 10,
              marginTop: 60
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <p>Donate earnings to charity</p>
              <Switch onClick={authStore.toggleDonate} on={authStore.donateEnabled} />
            </div>
            {authStore.donateEnabled ? (
              <div style={{ textAlign: "left" }}>
                <p style={{ marginTop: 25, paddingTop: 45, borderTop: "1px solid #eee" }}>
                  Select charity:
                </p>
                <CharityItem>
                  <img
                    src="/charities/ricebowls.jpg"
                    style={{ width: 60, height: 60, borderRadius: 40 }}
                  />
                  <div
                    style={{
                      marginLeft: 20,
                      maxWidth: 400
                    }}
                  >
                    <h4>Rice Bowls</h4>
                    <p style={{ padding: "10px 0" }}>
                      A non-profit that provides food & opportunities to awesome orphaned kids
                      around the world.
                    </p>
                    <a href="http://ricebowls.org/">ricebowls.org</a>
                  </div>
                </CharityItem>
                <p style={{ paddingTop: 50, fontStyle: "italic", opacity: 0.6 }}>
                  More charities coming soon. To suggest a charity, email team@tinymerch.com
                </p>
              </div>
            ) : null}
          </div>
        </AppPanel>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Payment.js